module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: [_vm.isList ? 'list' : ''],
    style: (_vm.videoPicture),
    on: {
      "click": function($event) {
        return _vm.watchVideo(_vm.videoLecture.id)
      }
    }
  }, [_c('div', {
    staticClass: "card-gradient",
    style: (_vm.gradientStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.videoSubjectName))]), _vm._v(" "), _c('div', {
    staticClass: "card-subtitle mb-2"
  }, [_vm._v(_vm._s(_vm.videoTitle))]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-action"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic-video-play.svg",
      "alt": "play icon"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33e81c3f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TextCard.vue
// module id = 1566
// module chunks = 1